export const NOTI_AGENT_REPORT_HANDLER_ID = "noti_agent_report_handler";
export const NOTI_ANALYZING_HANDLER_ID = "noti_analyzing_handler";
